import {clampProgress, safeJsonObject} from "src/v2/components/Workflow/workflow-execution"

const legacyMetadataValue = (metadata, field) => {
    const parsed = safeJsonObject(metadata)
    if (parsed[field] !== undefined) return parsed[field]
    if (typeof metadata !== "string") return null

    const expression = new RegExp(`["']?${field}["']?\\s*:\\s*["']?([^,"'}]+)`, "i")
    return metadata.match(expression)?.[1]?.trim() || null
}

export const normalizeCalculationExecution = (execution = {}) => {
    const total = Math.max(0, Number(execution.total_registros) || 0)
    const processed = Math.min(
        Math.max(0, Number(execution.total_registros_processados) || 0),
        total || Number(execution.total_registros_processados) || 0
    )

    return {
        ...execution,
        id: execution.uuid || execution.id,
        dag_id: execution.rotina || "",
        run_id: execution.uuid || null,
        contract_version: "v1",
        reference_date: legacyMetadataValue(execution.metadata, "data_referencia"),
        current_stage: null,
        progress_total: total,
        progress_processed: processed,
        progress_percent: clampProgress(total > 0 ? processed * 100 / total : 0),
        heartbeat_at: execution.atualizado_em || null,
        created_by_name: execution.nome_usuario || null,
        current_error: null,
        created_at: execution.criado_em || null,
        updated_at: execution.atualizado_em || null,
        capabilities: {
            detailed_progress: false,
            structured_errors: false,
            legacy_report: false,
        },
        stages: [],
        errors: [],
    }
}
